import { request } from './request.js'

export const getOffices = () => request.get('offices')
export const getOfficesById = id => request.get(`offices/${id}`)
